export var SelectDataTids = {
  root: 'Select__root',
  menu: 'Select__menu',
  label: 'Select__label'
};